import { Typography } from "@mui/material";
import { useEffect, useState } from "react";

import HNSColors from "../../../../../../ui library/HNSColors";
import { isEmptyValue } from "../../../helper/functions";
import { useStaticData } from "../../../hooks/useStaticData";
import NothingToShow from "../../NothingToShow";

import ChipList from "./ChipList";

function normalizeChipValues(value, field = {}) {
  if (Array.isArray(value)) {
    return value
      .map((item) => {
        if (typeof item === "string" || typeof item === "number") {
          return { label: String(item) };
        }

        if (
          typeof item === "object" &&
          item !== null &&
          field?.modelValueLabel
        ) {
          return {
            label: item[field.modelValueLabel] ?? String(item[field.modelValueKey] ?? ""),
            value: item[field.modelValueKey],
          };
        }

        return null;
      })
      .filter(Boolean);
  }

  if (isEmptyValue(value)) {
    return [];
  }

  if (typeof value === "string" || typeof value === "number") {
    return [{ label: String(value) }];
  }

  if (typeof value === "object" && value !== null && field?.modelValueLabel) {
    return [
      {
        label: value[field.modelValueLabel] ?? String(value[field.modelValueKey] ?? ""),
        value: value[field.modelValueKey],
      },
    ];
  }

  return [{ label: String(value) }];
}

export default function ChipField({ value, field = {} }) {
  const [displayValue, setDisplayValue] = useState(value);
  const availableInModel = field?.availableInModel ?? true;
  const { fetchDataValue } = useStaticData(field);

  useEffect(() => {
    let isMounted = true;

    const syncDisplayValue = async () => {
      if (!availableInModel) {
        const response = await fetchDataValue(value);
        if (isMounted) {
          setDisplayValue(response);
        }
        return;
      }

      setDisplayValue(value);
    };

    syncDisplayValue();

    return () => {
      isMounted = false;
    };
  }, [value, availableInModel, fetchDataValue]);

  const normalizedValues = normalizeChipValues(displayValue, field);

  if (normalizedValues.length === 0) {
    if (!isEmptyValue(field?.emptyDisplay)) {
      return (
        <Typography className="text-[14px]" sx={{ color: HNSColors.neutrals[500] }}>
          {field.emptyDisplay}
        </Typography>
      );
    }

    return <NothingToShow />;
  }

  return <ChipList values={normalizedValues} />;
}
